import { Component } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Component((node) => {
  const currentDateString = NonNullish(node.getAttribute('data-current-date-string'));
  const endDateString = NonNullish(node.getAttribute('data-end-date-string'));

  const currentDate = new Date(currentDateString);
  const endDate = new Date(endDateString);

  const update = () => {
    currentDate.setSeconds(currentDate.getSeconds() + 1);
    const timeLeft = endDate.getTime() - currentDate.getTime();

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    node.textContent = `${days} ${theme.strings.counter.days} ${hours} ${theme.strings.counter.hours} ${minutes} ${theme.strings.counter.minutes} ${seconds} ${theme.strings.counter.seconds}`;
  };

  update();
  setInterval(update, 1000);
});
